import type { SiteRagReport } from '../types/siteRag';

/** A quality/integrity hold withholds decision authority, not history access. */
export function isSavedReportDecisionSourceEligible(report: {
  qualityHold?: unknown;
  qualityHoldFindings?: unknown;
  isDraft?: unknown;
  generationTier?: unknown;
  requiresRegeneration?: unknown;
  degradedMode?: unknown;
} | null | undefined): boolean {
  if (!report) return false;
  return !report.qualityHold
    && (report.qualityHoldFindings == null || (Array.isArray(report.qualityHoldFindings) && report.qualityHoldFindings.length === 0))
    && report.isDraft !== true
    && report.generationTier !== 'draft'
    && report.requiresRegeneration == null
    && report.degradedMode !== true;
}

/**
 * Decide the newest summary first, then withhold its authority if held. Filtering
 * holds before sorting would revive an older GO after a newer failed review.
 * Callers must supply reports for the exact authorized site.
 */
export function latestExecutiveSummaryForDecision(reports: readonly SiteRagReport[]): SiteRagReport | undefined {
  let latest: SiteRagReport | undefined;
  let latestTime = -Infinity;
  let tiedUnavailable = false;
  for (const report of reports) {
    if (report.reportType !== 'executive-summary') continue;
    const time = typeof report.createdAt === 'string' ? Date.parse(report.createdAt) : NaN;
    // An undated candidate cannot establish which summary is current.
    if (!Number.isFinite(time)) return undefined;
    if (time > latestTime) {
      latest = report; latestTime = time; tiedUnavailable = !isSavedReportDecisionSourceEligible(report);
    } else if (time === latestTime && !isSavedReportDecisionSourceEligible(report)) tiedUnavailable = true;
  }
  return !tiedUnavailable && isSavedReportDecisionSourceEligible(latest) ? latest : undefined;
}
